import React, { useMemo, useState } from "react";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import { GlobalFilter } from "./GlobalFilter";
import chevRightRed from "../../../assets/icons/chevRightBlue.png";
import chevLeftRed from "../../../assets/icons/chevLeftBlue.png";
import styles from "./style.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import eye from "../../../assets/icons/eye2.png";
import redCross from "../../../assets/icons/cancelCross.png";
import greenTick from "../../../assets/icons/green Tick.png";
import userAlt from "../../../assets/images/user.svg";
import { userActions } from "../../../store/users";
// import { GlobalFilter } from "./GlobalFilter";

const NewCustomerTable = () => {
  const newUsers = useSelector((state) => state.users.newUsers);

  const dispatch = useDispatch();

  const checkEmptySpace = (string) => {
    if (string === "") {
      return "--";
    } else {
      return string;
    }
  };

  const navigate = useNavigate();
  const data = useMemo(() => newUsers, []);

  const onViewClick = (id) => {
    dispatch(userActions.setSelectedUserId(id));
    navigate(`/users/newUsers/:${id}`);
  };

  function capitalizeName(name) {
    return name.replace(/\b(\w)/g, (s) => s.toUpperCase());
  }

  const onImageError = (ev) => {
    ev.target.src = userAlt;
  };

  const checkInsurance = () => {};

  const COLUMNS_NEWCUSTOMER = [
    {
      Header: () => <p className={styles.headerID}>User ID</p>,
      accessor: "_id",
      Cell: (tableProps) => (
        <p className="cu_id">{String(tableProps.row.original._id).slice(-4)}</p>
      ),
    },
    {
      Header: () => <p className={styles.headerID}>Date</p>,
      accessor: "date",
      Cell: (tableProps) => (
        <p>
          {moment(tableProps.row.original.dl.createdAt).format("MM-DD-YYYY")}
        </p>
      ),
    },
    // {
    //   Header: "Time",
    //   accessor: "time",
    //   Cell: (tableProps) => (
    //     <p>{moment(tableProps.row.original.dl.createdAt).format("h:mm a")}</p>
    //   ),
    // },
    {
      Header: "User name",
      accessor: "name",
      Cell: (tableProps) => (
        <div className="nameAndImage">
          <img src={tableProps.row.original.image} onError={onImageError} />
          <p
            className="nameBox"
            // onClick={() => onRowClick(tableProps.row.original.name)}
          >
            {capitalizeName(tableProps.row.original.name)}
          </p>
        </div>
      ),
    },

    {
      Header: "Licence",
      accessor: "dl.licenceNumber",
      Cell: (tableProps) => (
        <div className="availContainer">
          {tableProps.row.original.dl.image !== "" ? (
            <img className="docAvail" src={greenTick} alt="Yes" />
          ) : (
            <img className="docAvail" src={redCross} alt="No" />
          )}
        </div>
      ),
    },
    {
      Header: "Insurance",
      accessor: "insurance.insuranceNumber",
      Cell: (tableProps) => (
        <div className="availContainer">
          {tableProps.row.original.insurance.image !== "" &&
          tableProps.row.original.insurance.insuranceNumber !== "" ? (
            <img className="docAvail" src={greenTick} alt="Yes" />
          ) : (
            <img className="docAvail" src={redCross} alt="No" />
          )}
        </div>
      ),
    },
    {
      Header: "Address",
      accessor: "address",
      Cell: (tableProps) => (
        <p className="address">
          {checkEmptySpace(tableProps.row.original.address)}
        </p>
      ),
    },

    {
      Header: "Actions",
      accessor: "actions",
      Cell: (tableProps) => (
        <div className="actionsCategories">
          <button
            className="btn-edit"
            onClick={() => onViewClick(tableProps.row.original._id)}
          >
            <img src={eye} alt="View" />
          </button>
        </div>
      ),
    },
  ];

  const columns = useMemo(() => COLUMNS_NEWCUSTOMER, []);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    prepareRow,
    state,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;

  return (
    <div className="containerSubRight">
      <div className="heading-container">
        <h1>New Users</h1>
        <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />

        {/* <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} /> */}
        {/* <ToastContainer />

        <ConfirmDeleteAdModal
          openDeleteModal={openDeleteModal}
          setOpenDeleteModal={setOpenDeleteModal}
          id={selectedID}
          notifySuccess={notifySuccess}
          notifyError={notifyError}
        /> */}
      </div>

      {!newUsers.length ? (
        <h1>No new users at the moment</h1>
      ) : (
        <>
          <div className="tableCont">
            <table {...getTableProps()}>
              <thead className="tableHeader">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr
                      className="table-row"
                      // onClick={() =>
                      //   navigate(`/users/newUsers/:${row.original._id}`)
                      // }
                      {...row.getRowProps()}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <>
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}{" "}
                            </td>
                          </>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="tableFooters">
            {/* <div className="pageInfo">
            {"\u00a0"} Go to page number : {"\u00a0"}
            <input
              type="number"
              default={pageIndex + 1}
              onChange={(e) => {
                const pageNumber = e.target.value
                  ? Number(e.target.value) - 1
                  : 0;
                gotoPage(pageNumber);
              }}
            />
          </div> */}
            <div className="tableButtons">
              {/* <button
              className="jumpButton"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {" "}
              Go to first page
            </button> */}
              <button
                className="tableNav"
                disabled={!canPreviousPage}
                onClick={() => previousPage()}
              >
                <img src={chevLeftRed} />
              </button>
              <p className="pageNumber">
                {" "}
                {"\u00a0"}
                Showing page {pageIndex + 1}
                {"\u00a0"}of {pageOptions.length}
              </p>
              <button
                className="tableNav"
                disabled={!canNextPage}
                onClick={() => nextPage()}
              >
                <img src={chevRightRed} />
              </button>
              {/* <button
              className="jumpButton"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              Go to last page
            </button> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NewCustomerTable;
